<template>
    <div>
        <div v-if="isAwaitingUserUpload">
            <feedback-track-upload-component
                :artist="artist"
                :feedback-product="feedbackProduct"
                :enrolment="enrolment"></feedback-track-upload-component>
        </div>
        <div v-else-if="isAwaitingArtistFeedback">
            <div class="row">
                <div class="col-md-4">
                    <img :src="artist.imageUris.cardThumb.url" class="img-fluid mb-3" />
                </div>
                <div class="col-md-8">
                    <h2>We've got your track!</h2>
                    <p>
                        Thanks for your submission.
                    </p>
                    <p>
                        {{ artist.name }} is now working on your feedback.
                    </p>
                    <p>
                        We'll drop you an email when it's ready.
                    </p>
                </div>
            </div>
        </div>
        <div v-else-if="isComplete">

            <h2>Your track</h2>

            <div class="mb-4">
                <div class="mb-1 card border shadow">
                    <div class="card-body">
                        <h5 class="card-title">{{ enrolment.track_name }}</h5>
                        <p class="card-text" v-html="nl2br(enrolment.track_description)"></p>
                        <audio controls>
                            <source :src="enrolment.trackFullUrl" type="audio/mpeg">
                            Your browser does not support the audio element.
                        </audio>
                    </div>
                </div>
            </div>

            <h2>Feedback from {{ artist.name }}</h2>

            <mux-video-component type="artist-feedback-enrolment-summary" :entity="enrolment"></mux-video-component>
            <div class="mb-2 mt-2" v-html="nl2br(enrolment.artist_feedback)"></div>

        </div>
    </div>
</template>

<script>
export default {
    props: {
        artist: {
            type: Object,
            default: null,
            required: true
        },
        feedbackProduct: {
            type: Object,
            default: null,
            required: true
        },
        enrolment: {
            type: Object,
            default: null,
            required: true
        },
    },

    data() {
        return {
            isBusy: false,
            isAwaitingUserUpload: false,
            isAwaitingArtistFeedback: false,
            isComplete: false,
            track_description: '',
            track_file: null,
            track_name: '',
        };
    },

    mounted() {
        console.log(this.artist);
        if(this.enrolment.teacher_feedback_product_enrolment_status.name === 'awaiting_user_upload') {
            this.isAwaitingUserUpload = true;
        } else if(this.enrolment.teacher_feedback_product_enrolment_status.name === 'awaiting_artist_feedback') {
            this.isAwaitingArtistFeedback = true;
        } else if(this.enrolment.teacher_feedback_product_enrolment_status.name === 'complete') {
            this.isComplete = true;
        }
    },

    methods: {
        onFileChanged(event) {
            this.file = event.target.files[0];
        },

        // Convert newlines to <br> tags
        nl2br (str) {
            if (typeof str === 'undefined' || str === null) {
                return '';
            }
            var breakTag = '<br>';
            return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
        },
    }
};
</script>
